import { Building, ChevronRight, Copyright, Mail, PhoneCallIcon, Zap } from 'lucide-react';
import footerLight from '@/assets/footer-light.png';
import { useNavigate } from 'react-router-dom';
export const Footer = () => {
  let navigate = useNavigate();
  return (
    <div className="relative mt-[4rem] flex w-full flex-wrap justify-center overflow-hidden bg-[#121212] font-inter">
      <div className="relative w-full max-w-[144rem] px-[8rem] md:px-[8rem]">
        <img
          alt="footer light"
          className="absolute right-[-24rem] z-[0] md:right-[-27rem]"
          src={footerLight}
        />
        <img
          alt="footer light"
          className="absolute left-[-16rem] z-[0] md:left-[-18rem]"
          src={footerLight}
        />
        <div className="z-[1] mt-[4rem] flex w-full flex-wrap items-center justify-between gap-[3rem]">
          <div className="flex flex-wrap items-center justify-start gap-[0.5rem]">
            <img alt="ico" className="h-[5rem] w-[5rem]" src="/favicon.png" />
            <h1 className="mt-[-0.1rem] text-[2.2rem] font-[800] leading-[100%] text-[#ff8c00]">
              Contractors
              <br />
              <span className="text-[#0273c9]">Limited</span>
            </h1>
          </div>
        </div>
        <div className="z-[1] mt-[3rem] flex w-full flex-row flex-wrap items-start justify-between gap-y-[3rem]">
          <div className="w-full text-white sm:w-[30rem]">
            <div className="flex items-center justify-start gap-[1rem]">
              <div className="flex h-[3rem] w-[3rem] items-center justify-center rounded-full border border-orange-500">
                <Zap size={'1.6rem'} className="text-red-500" />
              </div>
              <h1 className="text-[2rem] font-[700]">About KU</h1>
            </div>
            <p className="mt-[2rem] text-[1.6rem] font-[400]">
              KU Contractors Limited provides expert maintenance, refurbishment, and construction
              solutions — covering everything from plumbing and electrical works to roofing,
              flooring, and landscaping.
            </p>
            <div className="mt-[3rem] flex flex-row flex-wrap justify-center gap-[1rem] border-[2px] border-[#666666] bg-[#2b2e35] p-[1rem]">
              <div className="flex h-[5rem] w-[5rem] items-center justify-center rounded-full bg-orange-500">
                <PhoneCallIcon className="text-[2.4rem] text-white" />
              </div>
              <div className="flex flex-col gap-[0.2rem] text-[1.6rem] text-white">
                <p className="font-[500]">Call Us Any time:</p>
                <p className="text-[2rem] font-[600]">07454-926-222</p>
              </div>
            </div>
          </div>
          <div className="text-white">
            <div className="flex items-center justify-start gap-[1rem]">
              <div className="flex h-[3rem] w-[3rem] items-center justify-center rounded-full border border-orange-500">
                <Zap size={'1.6rem'} className="text-red-500" />
              </div>
              <h1 className="text-[1.8rem] font-[700] md:text-[2rem]">Explore</h1>
            </div>
            <div className="mt-[2rem]">
              {[
                { label: 'Home', link: '/' },
                { label: 'About Us', link: '/about-us' },
                { label: 'Services', link: '/services' },
                { label: 'Contact Us', link: '/contact-us' },
              ].map(({ label, link }, i) => (
                <div
                  key={i}
                  onClick={() => {
                    if (link) {
                      navigate(link);
                    }
                  }}
                  className="flex cursor-pointer items-center gap-[0.8rem] text-[1.6rem] font-[400] text-[#FFFFFF] transition-colors duration-300 hover:text-[#e24e1f]"
                >
                  <ChevronRight size={16} strokeWidth={1.8} className="" />
                  <p className="duration-3 00 text-[1.6rem] font-[400] transition-colors hover:text-[#e24e1f]">
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="text-white">
            <div className="flex items-center justify-start gap-[1rem]">
              <div className="flex h-[3rem] w-[3rem] items-center justify-center rounded-full border border-orange-500 bg-black">
                <Zap size={'1.6rem'} className="text-red-500" />
              </div>
              <h1 className="text-[1.8rem] font-[700] md:text-[2rem]">Working Hours</h1>
            </div>
            <div className="mt-[2rem] flex flex-col gap-[1rem]">
              <p className="text-[1.6rem] font-[600] text-white md:text-[1.8rem]">Available 24/7</p>
              <p className="text-[1.4rem] font-[400] text-gray-300 md:text-[1.6rem]">
                Always here when you need us
              </p>
            </div>
          </div>
          <div className="w-full text-white sm:w-[30rem]">
            <div className="flex items-center justify-start gap-[1rem]">
              <div className="flex h-[3rem] w-[3rem] items-center justify-center rounded-full border border-orange-500">
                <Zap size={'1.6rem'} className="text-red-500" />
              </div>
              <h1 className="text-[1.8rem] font-[700] md:text-[2rem]">Get In Touch</h1>
            </div>
            <div className="mt-[2rem] flex flex-col gap-[1rem]">
              <div className="flex cursor-pointer items-center gap-[0.8rem] text-[1.6rem] font-[400] text-[#FFFFFF]">
                <Building size={'2rem'} strokeWidth={1.8} className="" />
                <p className="w-[calc(100%-3rem)] text-[1.6rem] font-[400]">
                  {' '}
                  125A Crossbrook Street, Cheshunt, Hertfordshire, United Kingdom, EN8 8LY
                </p>
              </div>
              <div className="flex cursor-pointer items-center gap-[0.8rem] text-[1.6rem] font-[400] text-[#FFFFFF]">
                <Mail size={'2rem'} strokeWidth={1.8} className="" />
                <p className="w-[calc(100%-3rem)] text-[1.6rem] font-[400]">
                  {' '}
                  office@kucontractors.com
                </p>
              </div>

              <div className="flex cursor-pointer items-center gap-[0.8rem] text-[1.6rem] font-[400] text-[#FFFFFF]">
                <PhoneCallIcon size={'2rem'} strokeWidth={1.8} className="" />
                <p className="w-[calc(100%-3rem)] text-[1.6rem] font-[400]">07454-926-222</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="z-[66666] mt-[4rem] flex h-[9rem] w-full items-center justify-center bg-black px-[2rem]">
        <div className="flex w-full max-w-[144rem] flex-wrap items-center justify-center gap-[1rem] md:justify-between">
          <div className="flex flex-row items-start gap-[0.4rem] text-[1.6rem] font-[400] leading-[145%] text-[#DDDDDD]">
            <Copyright strokeWidth={2} size={'1.4rem'} className="text-[1.4rem] text-white" />
            <p className="w-[calc(100%-1.4rem)] text-center text-[1.4rem] font-[600] leading-[100%] md:text-[1.6rem] md:font-[500]">
              Copyright {new Date().getFullYear()} <strong>KU Contractors Limited</strong> . All
              Rights Reserved
            </p>
          </div>
          <p className="cursor-pointer text-[1.4rem] font-[600] leading-[3rem] text-[#DDDDDD] md:text-[1.6rem] md:font-[500]">
            <span
              onClick={() => {
                navigate('/privacy-policy');
              }}
              className="duration-3 transition-colors hover:text-[#e24e1f]"
            >
              {' '}
              Privacy Policy{' '}
            </span>{' '}
            -
            <span
              onClick={() => {
                navigate('/terms-conditions');
              }}
              className="duration-3 transition-colors hover:text-[#e24e1f]"
            >
              {' '}
              Terms & Conditions
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
